import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { BatchingRules } from '@types-lib';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';

export class ProductsByServiceCodeEndpoints {
  private env = inject<PIMSEnvironment>(ENVIRONMENT);
  httpClient = inject(HttpClient);

  get(code: string) {
    return this.httpClient.get<BatchingRules.ApiProduct[]>(`${this.env.constants.API_URL}/categories/${code}/products`);
  }
}
